/* eslint-disable import/prefer-default-export */
export const uniqueValidation = (nameList, noun) => (input) => {
  const trimmed = input.trim();
  const isUnique =
    nameList.map(givenName => givenName.toLowerCase()).indexOf(trimmed.toLowerCase()) === -1;
  return { validInput: isUnique, error: isUnique ? '' : `${noun} must be unique.` };
};

export const maxLengthValidation = (maxLength, noun) => (input) => {
  const trimmed = input.trim();
  const isSafe = trimmed.length <= maxLength;
  return {
    validInput: isSafe,
    error: isSafe ? '' : `${noun} must not exceed ${maxLength} characters.`,
  };
};

export const emptyValidation = noun => (input) => {
  const isEmpty = input === undefined || input === null || input.length === 0;
  return { validInput: !isEmpty, errors: [isEmpty ? `Please enter a ${noun}.` : ''] };
};

const aggregate = (empty, functions) => {
  const aggregateValidationFunction = (input) => {
    const result = empty(input);
    if (result.validInput) {
      return functions.map(givenFn => givenFn(input)).reduce(
        (a, b) => ({
          validInput: a.validInput && b.validInput,
          errors: !b.validInput ? a.errors.concat([b.error]) : a.errors,
        }),
        { validInput: true, errors: [] },
      );
    }

    return result;
  };

  return aggregateValidationFunction;
};

export const create = (nameList, maxLength, noun) =>
  aggregate(emptyValidation(noun), [
    uniqueValidation(nameList, noun),
    maxLengthValidation(maxLength, noun),
  ]);
